
import React from 'react';
import { DashboardTable } from "../dashboard-table";
import {centsToString } from "../../../lib/currency-utils";
import {is_uuid} from "../../../lib/uuid";
import { sprintf } from "sprintf-js";
import {Info, Spinner} from "../../funcs/utils";
import { TabContainer } from "../tab-container";
import { deep_copy } from "../../../lib/js-utils";
import {PaymentsContainer2, render_header} from "./common";
import {
  ACCOUNT_FUNDING_PAYMENTS_CARD_TABLE_WIDTH,
  DEVICE_WIDTH,
  SUPER_ADMIN,
  USER
} from "../../../lib/constants";
import {date_to_EST} from "../../../lib/time";

const render_price = (amt_cents, style) => {
  const text = centsToString(amt_cents);
  return (<span style={style}>{text}</span>);
};

const render_destination = (component, dest_id) => {
  if (is_uuid(dest_id)) {
    if (!(dest_id in component.state.funding_sources)) {
      return (<span>UNKNOWN</span>);
    }
    const dest = component.state.funding_sources[dest_id];
    return (<span>{dest.name}</span>);
  }
  return (<span>{dest_id}</span>);
};

const render_date_EST = time_sec => {
  const date = new Date(time_sec * 1000);
  const date_est = date_to_EST(date);
  const text = sprintf("%02d-%02d-%04d %02d:%02d:%02d %s EST",
    date_est.getMonth() + 1, date_est.getDate(), date_est.getFullYear(),
    date_est.getHours() % 12, date_est.getMinutes(), date_est.getSeconds(),
    date_est.getHours() >= 12 ? "PM" : "AM");
  return (<span>{text}</span>);
}

const get_columns = (dataIsNestedArray) => {
    const headers = dataIsNestedArray[0];
    const columns = headers.length;
    return columns;
}

const render_current = (component, acct_index) => {
  const username = component.props.username || component.props.user.username;
  let current_payments = [];

  if (username in component.props.userPayments) {
    current_payments = component.props.userPayments[username].current_payments;
  }
  const show_id = component.props.user.account_type !== USER || component.state.debug;

  const data = [
    [
      render_header("Amount"),
      render_header("Source"),
      render_header("Destination"),
      render_header("Time"),
      render_header("State"),
    ],
  ];
  if (show_id) {
    data[0].unshift("Queue ID");
  }

  const state_style = {
    textTransform: "capitalize",
  }

  const items = current_payments.filter(item => item.destination_index === acct_index);

  items.forEach(payment => {
    let state = payment.state;
    if (!show_id && (
      state === "multi-leg-paused" || state === "segregated-leg-paused")) {
      state = "Pending";
    }
    const line = [
      render_price(payment.amt_cents),
      payment.source,
      render_destination(component, payment.destination),
      render_date_EST(payment.created_sec),
      (<span style={state_style}>{state}</span>),
    ];
    if (show_id) {
      line.unshift(payment.queue_id);
    }
    data.push(line);
  });

  const div_style = {
      overflow: "auto"
  }
  const td_style = {
    whiteSpace: "nowrap",
  }
  const table_layout = {
    width: "100%",
    tableLayout: "auto",
  }

  return (
    <div style={div_style}>
      <DashboardTable
        tableStyle={table_layout}
        hLines={true}
        align={["left", "left", "left", "left", "left"]}
        data={data}
        td_style={td_style}
      />
    </div>
  )
};

const render_past = (component, acct_index) => {
  const username = component.props.username || component.props.user.username;
  let past_payments = [];

  if (username in component.props.userPayments) {
    past_payments = component.props.userPayments[username].past_payments;
  }

  const show_queue_id =
    component.props.user.account_type !== USER || component.state.debug;
  const data = [
    [
      render_header("Amount"),
      render_header("Source"),
      render_header("Destination"),
      render_header("Date"),
    ],
  ];
  if (show_queue_id) {
    data[0].unshift(render_header("Queue ID"));
  }

  const items = past_payments.filter(item => item.index === acct_index);

  items.forEach(payment => {
    const date = sprintf("%02d-%02d-%04d",
      payment.last_date.month, payment.last_date.day, payment.last_date.year);

    const new_line = [
      render_price(payment.amt_cents),
      payment.source,
      payment.destination,
      (<span>{date}</span>),
    ];
    if (show_queue_id) {
      new_line.unshift((<span>{payment.queue_id}</span>));
    }
    data.push(new_line);

    if (show_queue_id && (payment.ach_id || payment.trace_id)) {
      const ach_id = payment.ach_id || "UNKNOWN";
      const trace_id = payment.trace_id || "UNKNOWN";
      const id_line = [
        "",
        (<span>Ach ID: {ach_id}</span>),
        (<span>Trace ID: {trace_id}</span>),
        (<div/>),
        (<div/>),
        (<div/>),
      ];
      data.push(id_line);
    }
  });

  const div_style = {
      overflow: "auto"
  }
  const td_style = {
    whiteSpace: "nowrap",
  }
  
  return (
    <div style={div_style}>
      <DashboardTable
        tableStyle={{width: "100%", tableLayout: "auto"}}
        hLines={true}
        align={["left", "left", "left", "left"]}
        data={data}
        td_style={td_style}
      />
    </div>
  )
};

const parse_email = username => {
  const index = username.search("_");
  return username.substr(index + 1);
}

const render_to_username = (to_username, span_style) => {

  const text = sprintf("%s - %d",
    parse_email(to_username.username), to_username.index);
  return (<span style={span_style}>{text}</span>);
}

const render_queued_items = items => {

  if (!items) {
    return null;
  }

  const data = [
    [
      render_header("Amount"),
      render_header("From"),
      render_header("To"),
      render_header("Date"),
      render_header("Payment ID"),
    ],
  ];

  const span_style = {
    fontSize: "1rem",
  }
  items.forEach(item => {
    const date_str = sprintf("%02d-%02d-%04d %02d:%02d:%02d",
      item.created.month, item.created.day, item.created.year,
      item.created.hour, item.created.minute, item.created.sec);

    const new_line = [
      render_price(item.amt_cents, span_style),
      (<span style={span_style}>{parse_email(item.payment_from.username) }</span>),
      render_to_username(item.payment_to, span_style),
      (<span style={span_style}>{date_str}</span>),
      (<span style={span_style}>{item.payment_from.payment_id}</span>),
    ];
    data.push(new_line);
  });

  const div_style = {
    overflow: "auto"
  }
  const td_style = {
    //width: width,
    whiteSpace: "nowrap",
  }

  return (
    <div style={div_style}>
      <DashboardTable
        col_widths={[0.5, 1, 1, 0.5, 1]}
        tableStyle={{width: "100%"}}
        hLines={true}
        align={["left", "left", "left", "left"]}
        data={data}
        td_style={td_style}
      />
    </div>
  )
}

const render_future = (component, acct_index) => {

  const show_id = component.props.user.account_type !== USER || component.state.debug;

  const username = component.props.username || component.props.user.username;
  let future_payments = [];

  if (username in component.props.userPayments) {
    future_payments = component.props.userPayments[username].future_payments;
  }

  const data = [
    [
      render_header("Amount"),
      render_header("Date"),
      render_header("Description"),
    ],
  ];
  if (show_id) {
    data[0].unshift(render_header("Queue ID"));
  }

  const items = future_payments.filter(item => item.index === acct_index);

  items.forEach(payment => {
    const date = sprintf("%02d-%02d-%04d",
      payment.future_date.month, payment.future_date.day, payment.future_date.year);
    const line = [
      render_price(payment.amt_cents),
      (<span>{date}</span>),
      (<span>{payment.description}</span>),
    ];

    if (show_id) {
      line.unshift((<span>{payment.queue_id}</span>));
    }
    data.push(line);
  });

  const width = ACCOUNT_FUNDING_PAYMENTS_CARD_TABLE_WIDTH / get_columns(data)
  
  const div_style = {
      overflow: "auto"
  }
  const td_style = {
    width: width,
    whiteSpace: "nowrap",             
  }

  return (
    <div style={div_style}>
      <DashboardTable
        tableStyle={{width: "100%"}}
        hLines={true}
        align={["left", "left", "left"]}
        data={data}
        td_style={td_style}
      />
    </div>
  );
};

const on_tab_click = (component) =>  (tab_id) => {
  const args = deep_copy(component.props.args);
  args.tab = tab_id;
  component.props.navigatePath(component.props.path, args);
}


const PaymentsCard = props => {

  const component = props.component;
  const is_admin = component.props.user.account_type === SUPER_ADMIN;
  const is_loading = component.props.userPayments.loading;

  const device = {
    width: component.props.app.width,
  }
  const do_medium = component.props.app.width < DEVICE_WIDTH.medium;

  const spinner = (
    <div align={"center"} style={{fontSize: "2rem", margin: "2rem"}}>
      <Spinner/>
    </div>
  );
  const acct_index = parseInt(component.props.acct_index, 10);

  const tabs = [
    {
      label: "Current",
      id: "current",
      content: is_loading ? spinner : render_current(component, acct_index),
    },
    {
      label: "Past",
      id: "past",
      content: is_loading ? spinner : render_past(component, acct_index),
    },
    {
      label: "Future",
      id: "future",
      content: is_loading ? spinner : render_future(component, acct_index),
    },
  ];
  if (is_admin) {
    tabs.push({
      label: "Queued Payments",
      id: "queued_payments",
      content: is_loading
        ? spinner
        : render_queued_items(component.state.queued_payments),
    })
    tabs.push({
      label: "Queued Debits",
      id: "queued_debits",
      content: is_loading
        ? spinner
        : render_queued_items(component.state.queued_debits),
    })
  }
  const curr_tab = component.props.args.tab;
  const info_text = "This will show you the status of a deposit currently in process, a history of past transactions or a record of future planned contributions.";
  const info = (
    <Info
      id={"deposit"}
      text={info_text}
      popup_style={{ width: "30rem" }}
      style={{fontSize: do_medium ? "1rem" : "1.5rem"}}
      component={component}/>
  );

  return (
    <PaymentsContainer2
      client={component.props.client}
      device={device}
      suffix={info}
      title={"Deposits"}>
      <TabContainer tabs={tabs} onClick={on_tab_click(component)} current={curr_tab}/>
    </PaymentsContainer2>
  );
}

const payments_card_state = () => {
  return {
    current_payments: [],
    funding_sources: {},
    past_payments: [],
    future_payments: [],
  }
};

export { PaymentsCard, payments_card_state }